export default function CheckoutSkeleton({
    showDiscount = true,
    rowCount = 4
}: {
    showDiscount?: boolean;
    rowCount?: number;
}) {
    return (
        <div className='flex flex-col gap-4'>
            {showDiscount ? (
                <div className='animate-pulse rounded-xl bg-gray-100 p-4'>
                    <div className='mb-4 flex items-center justify-between'>
                        <div className='h-3 w-40 rounded bg-gray-200' />
                        <div className='h-3 w-10 rounded bg-gray-200' />
                    </div>
                    <div className='mb-1 h-3 w-44 rounded bg-gray-200' />
                    <div className='h-3 w-20 rounded bg-gray-200' />
                </div>
            ) : null}
            <div className='animate-pulse rounded-xl bg-gray-100 p-4'>
                <div className='mb-6 h-4 w-40 rounded bg-gray-300' />
                <ul className='divide-y divide-gray-200'>
                    {[...Array(rowCount)].map((_, i) => (
                        <AmountRow key={`ar-${i}`} />
                    ))}
                </ul>
            </div>
            <div className='flex h-12 w-full animate-pulse items-center justify-center rounded-xl bg-gray-200'>
                <div className='h-3 w-16 bg-gray-300' />
            </div>
        </div>
    );
}

function AmountRow() {
    return (
        <li className='flex items-center justify-between pt-4 pb-2.5 first:pt-0 last:pb-0'>
            <div className='h-3 w-16 rounded bg-gray-200' />
            <div className='h-3 w-20 rounded bg-gray-200' />
        </li>
    );
}

